import React, { useState, useEffect } from "react";
import DefaultLayout from "../../../layout/vendor/DefaultLayout";
import {
  IoSearch,
  IoFilterSharp,
  IoArrowForwardSharp,
  IoArrowBackSharp,
} from "react-icons/io5";
import { FiDownload, FiEdit2 } from "react-icons/fi";
import { FaPlus, FaArrowRight, FaRegTrashAlt } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Card,
  Badge,
  Pagination,
  Spinner,
} from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "react-query";
import api from "../../../utils/helper";
import Footer from "../../../components/Footer";
import { useAlerts } from "../../../context/AlertContext";
import { useAuth } from "../../../context/AuthContext";
import Delete from "../../../components/Delete";
import { useIDsContext } from "../../../context/IDsContext";
import { URLS } from "../../../utils/URL";

const CollegeList = () => {
  const [collegeToDelete, setCollegeToDelete] = useState(null);
  const [collegeNameToDelete, setCollegeNameToDelete] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { userID } = useAuth();
  console.log(userID, "userID");
  const { vendorName } = useIDsContext();
  console.log("selectedvendorName:", vendorName);
  const queryClient = useQueryClient();
  const { showSuccess, showError } = useAlerts();
  const [showDelete, setShowDelete] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const { token } = useAuth(); // Fetch token from AuthContext
  const [selectedColleges, setSelectedColleges] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      setCurrentPage(1); // Reset to first page on new search
    }, 500); // 500ms delay

    return () => {
      clearTimeout(timerId);
    };
  }, [searchTerm]);

  const { data, isLoading, error } = useQuery(
    ["colleges", userID, currentPage, itemsPerPage, debouncedSearchTerm],
    () =>
      api.get(
        `/super-admin/colleges?vendorId=${userID}&page=${currentPage}&limit=${itemsPerPage}${
          debouncedSearchTerm ? `&search=${debouncedSearchTerm}` : ""
        }`,
        {
          headers: { Authorization: `Baarer ${token}` }, // Include token
        }
      ),
    {
      enabled: !!userID,
      onError: (err) => {
        console.error(
          "Error fetching colleges:",
          err.response?.data?.message || err.message
        );
      },
    }
  );

  console.log(data, "Data");

  const handleExport = () => {
    console.log("report execute");
    // Construct the URL with the existing search parameter if any
    const exportUrl = `/super-admin/colleges?vendorId=${userID}&downloadCSV=true&csvFields=firstname,lastname,email${
      debouncedSearchTerm ? `&search=${debouncedSearchTerm}` : ""
    }`;

    // Call the API with the download flag
    api
      .get(exportUrl, { responseType: "blob" })
      .then((response) => {
        // Create a blob URL from the response data
        console.log(response.data, "csv");

        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Create a temporary anchor element
        const link = document.createElement("a");
        link.href = url;

        // Set the file name (you can adjust this based on your API response)
        link.setAttribute("download", "colleges.csv");

        // Append to the document, click it, and then remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revoke the blob URL to free up memory
        window.URL.revokeObjectURL(url);

        showSuccess("Colleges list exported successfully!");
      })
      .catch((error) => {
        showError(
          error?.response?.data?.message || "Failed to export colleges"
        );
        console.error("Export error:", error);
      });
  };

  const deleteMutation = useMutation(
    (collegeID) => api.delete(`/super-admin/colleges/${collegeID}`),
    {
      onSuccess: (response) => {
        showSuccess(response.data?.message || "Deleted successfully!");
        console.log("Deleted successfully!", response);
        queryClient.invalidateQueries("colleges");
      },
      onError: (error) => {
        showError(error?.response?.data?.message || "Failed to deleted: ");
        console.log("Failed to deleted: " + error.message);
      },
    }
  );

  const handleDelete = (id, collegeName) => {
    // Store the ID to be deleted
    setCollegeToDelete(id);
    setCollegeNameToDelete(collegeName);
    setShowDelete(true);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Ensure data.vendors exists and is an array
  const colleges = data?.data?.data?.colleges || [];
  const totalRecords = data?.data?.data?.totalRecords || 0;
  console.log(totalRecords, "TotalRecords");

  const totalPages = data?.data?.data?.totalPages || 1;

  const handleAddCollege = () => {
    navigate("/vendor/add-college", {
      state: { vendorID: userID, isEdit: false, vendorName },
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedColleges(colleges.map((college) => college._id));
    } else {
      setSelectedColleges([]);
    }
  };

  const handleSelectOne = (id) => {
    setSelectedColleges((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <DefaultLayout>
      <div className="bgNav d-block d-lg-none pb-5 px-1 position-relative">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h2 className="heading mb-0 px-3">
            <span className="linkHref">{vendorName} </span>
            <span className=" text-light fw-bold">
              <FaArrowRight className="mx-1" /> Colleges
            </span>
          </h2>
          <Badge pill className="header-badge mx-2">
            {totalRecords} colleges
          </Badge>
        </div>
        <div className="d-flex justify-content-between px-2 mt-3">
          <div className="input-group me-3" style={{ maxWidth: "150px" }}>
            <span className="input-group-text bg-light border-secondary-subtle">
              <IoSearch color="#344054" size={12} />
            </span>
            <input
              type="text"
              className="form-control border-secondary-subtle"
              placeholder="Search..."
              aria-label="Search"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
          <Button
            variant="light"
            className="me-2 btn-sec"
            onClick={handleExport}
          >
            <FiDownload color="#344054" size={16} className="me-2" /> Export
          </Button>
          <Button
            color="#60B1FF"
            onClick={() => handleAddCollege()}
            className="btn-sec"
            style={{ border: "transparent" }}
          >
            <FaPlus size={16} className="me-2" /> Add New
          </Button>
        </div>
      </div>

      <Container
        fluid
        className="main-container vendor-container mt-0 mt-md-4 ps-auto ps-md-0"
      >
        {/* Header Section */}
        <Card className="fotm-card">
          <Card.Header className="heading d-none d-lg-block">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex gap-2 align-items-center">
                <h2 className="text-muted venhead mb-0">
                  {/* <Link to="/vendor/colleges" className="linkHref"> */}
                  <span className="linkHref">{vendorName} </span>
                  {/* </Link>{" "} */}
                  <span className="venhead fw-bold">
                    {" "}
                    <FaArrowRight /> Colleges
                  </span>
                </h2>
                <Badge pill className="header-badge">
                  {totalRecords} colleges
                </Badge>
              </div>
              <div className="d-flex align-items-center">
                <div className="input-group me-3" style={{ maxWidth: "200px" }}>
                  <span className="input-group-text bg-light border-secondary-subtle">
                    <IoSearch color="#344054" size={16} />
                  </span>
                  <input
                    type="text"
                    className="form-control border-secondary-subtle"
                    placeholder="Search colleges..."
                    aria-label="Search"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </div>
                <Button
                  variant="outline-secondary"
                  className="me-2 btn-sec"
                  onClick={handleExport}
                >
                  <FiDownload color="#344054" size={16} /> Export
                </Button>
                <Button
                  color="#60B1FF"
                  onClick={() => handleAddCollege()}
                  className="btn-sec"
                >
                  <FaPlus size={16} /> Add New
                </Button>
              </div>
            </div>
          </Card.Header>
          {/* <div></div> */}

          {isLoading ? (
            <div className="text-center">
              <Spinner size="md" />
            </div>
          ) : (
            <Table className="p-0 table-center" responsive>
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="allSelect"
                      checked={
                        selectedColleges.length === colleges.length &&
                        colleges.length > 0
                      }
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th>College Name</th>
                  <th>Students</th>
                  <th>Teachers</th>
                  <th>Available Courses</th>
                  <th>Location</th>
                  {/* <th>Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {error ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      <div className="alert " role="alert">
                        {error.response?.data?.message ||
                          "Something went wrong."}
                      </div>
                    </td>
                  </tr>
                ) : isLoading ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : colleges?.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No colleges found.
                    </td>
                  </tr>
                ) : (
                  [...colleges]
                    .sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                    ) // 🧠 Sort colleges by createdAt DESC
                    .map((college) => (
                      <tr key={college._id}>
                        <td>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="allSelect"
                            checked={selectedColleges.includes(college._id)}
                            onChange={() => handleSelectOne(college._id)}
                          />
                        </td>
                        <td>
                          <div className="textlogo">
                            <img
                              src={
                                college.profile_img
                                  ? URLS.IMG_URL + college.profile_img
                                  : "/images/bajaj.png"
                              }
                              alt="Vendor Logo"
                              className="rounded-circle "
                              width={42}
                              height={42}
                            />
                            <span className="mb-0 college-name-table">
                              {college.name}
                            </span>
                          </div>
                        </td>
                        <td>{college.studentCount || 0}</td>
                        <td>{college.teacherCount || 0}</td>
                        <td>{college.courseCount || 0}</td>
                        <td>{college.location}</td>
                        <td>
                          <div className="d-flex gap-2">
                            <FaRegTrashAlt
                              color="#475467"
                              onClick={() =>
                                handleDelete(college._id, college.name)
                              }
                            />
                            <FiEdit2
                              color="#475467"
                              onClick={() =>
                                navigate("/vendor/add-college", {
                                  state: {
                                    vendorID: college.vendor,
                                    college: college,
                                    isEdit: true,
                                  },
                                })
                              }
                              style={{ cursor: "pointer" }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </Table>
          )}
          {totalPages > 1 && (
            <Pagination className="d-flex justify-content-between align-items-center p-2">
              <Button
                variant="outline-dark fw-bold"
                className="me-2"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <IoArrowBackSharp size={20} /> Previous
              </Button>
              <div className="d-flex">
                {Array.from({ length: totalPages }).map((_, idx) => (
                  <Pagination.Item
                    className="mx-2"
                    key={idx + 1}
                    active={idx + 1 === currentPage}
                    onClick={() => handlePageChange(idx + 1)}
                  >
                    {idx + 1}
                  </Pagination.Item>
                ))}
              </div>
              <Button
                variant="outline-dark fw-bold pagination-prev-button"
                className="me-2"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next <IoArrowForwardSharp size={20} />
              </Button>
            </Pagination>
          )}
        </Card>
      </Container>
      <div className="d-none d-lg-block">
        <Footer />
      </div>
      <Delete
        show={showDelete}
        close={() => setShowDelete(false)}
        handleDelete={() => {
          deleteMutation.mutate(collegeToDelete);
          setShowDelete(false);
        }}
        title="Delete College"
        name={collegeNameToDelete}
      />
    </DefaultLayout>
  );
};

export default CollegeList;
